import React, { useState, useEffect, useCallback } from "react";
import Loader from "../Loader";
import ChatMessage from "./ChatMessage";
import InputField from "./InputField";
import { socketurl } from "../../config/index";
import ImgMaximize from "../../assets/maximize.png";
import ImgMinimize from "../../assets/minimize.png";

const ChatBot = ({
  productId,
  userId,
  maximized,
  minimized,
  onMaximizeClick,
}) => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    if (!socket) return;

    setLoading(true);

    socket.onopen = () => {
      console.log("Chat open");
      setLoading(false);
      setMessages((prev) => {
        if (prev.length) return prev;
        let str = "Do you have any questions about this product?";
        return [...prev, { text: str, sender: "bot" }];
      });
    };
    socket.onmessage = (event) => {
      let data = JSON.parse(event.data);
      // console.log(data, "data");
      const msgtoAdd =
        typeof data === "string"
          ? [{ text: JSON.parse(data).answer, sender: "bot" }]
          : [
              { text: data.question, sender: "You" },
              { text: data.answer, sender: "bot" },
            ];
      setMessages((prevMessages) => [...prevMessages, ...msgtoAdd]);
      setLoading(false);
      setIsSubmitting(false);
    };
    socket.onerror = (error) => {
      console.log("Chat error: ", error);
      setIsSubmitting(false);
      setLoading(false);
    };
    socket.onclose = (event) => {
      console.log("Chat closed: ", event);
      setLoading(false);
      setIsSubmitting(false);
    };
  }, [socket]);

  useEffect(() => {
    if (!productId || !userId) return;

    setLoading(true);
    const ws = new WebSocket(`${socketurl}/${userId}/${productId}`);
    setSocket(ws);

    return () => {
      ws.close();
      setSocket(null);
    };
  }, [productId, userId]);

  const sendMessage = useCallback(
    (message) => {
      if (message.trim() === "" || !socket) return;
      setIsSubmitting(true);
      const newMessage = { text: message, sender: "You" };
      setMessages((prev) => [...prev, newMessage]);
      if (socket.readyState === WebSocket.OPEN) {
        socket.send(message); // Send message if WebSocket is open
        // console.log("Message sent:", message);
      }
    },
    [socket]
  );

  return (
    <div
      className={`ai-section d-flex flex-column ${
        maximized ? "" : "summary-collapsed"
      } ${minimized ? "" : "border"}`}
      style={{
        height: minimized ? 0 : "100%",
      }}
    >
      {/* HEADER */}
      <div className="section-header d-flex justify-content-between align-items-center px-3 py-2 border-bottom">
        <h4 className="mb-0">Chat</h4>

        <button
          className="btn btn-sm"
          onClick={onMaximizeClick}
          title={maximized ? "Minimize" : "Maximize"}
        >
          <img src={maximized ? ImgMinimize : ImgMaximize} alt="full-screen" />
        </button>
      </div>
      <div
        className="messages"
        style={{
          display: minimized ? "none" : "block",
        }}
      >
        {messages.map((msg, index) => (
          <ChatMessage key={index} message={msg} />
        ))}
      </div>
      <div
        className="p-2"
        style={{
          display: minimized ? "none" : "block",
        }}
      >
        <InputField
          onSubmit={sendMessage}
          submitting={isSubmitting}
          disabled={loading}
        />
      </div>
      {loading && <Loader />}
    </div>
  );
};

export default ChatBot;
